import { render } from "./CatalogItemsPage.vue?vue&type=template&id=e033e68c&scoped=true"
import script from "./CatalogItemsPage.vue?vue&type=script&lang=js"
export * from "./CatalogItemsPage.vue?vue&type=script&lang=js"

import "./CatalogItemsPage.vue?vue&type=style&index=0&id=e033e68c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e033e68c"]])

export default __exports__